import { MStorage, expriseSevenDays, MStorageEnum } from "./storage";

const HISTORY_KEY = MStorageEnum.LOCAL_HOTEL_SEARCH_HISTORY;

export function getLocalHistory(): any[] {
  return MStorage.getStorageSync(HISTORY_KEY) || [];
}

function setLocalHistory(history: any[]): void {
  MStorage.setStorageSync(HISTORY_KEY, history, expriseSevenDays);
}

/**
 * 添加一条新的历史记录到本地
 * @param newItem 要添加的新记录项
 */
export function addLocalHistoryItem(newItem: any): void {
  let currentHistory = getLocalHistory();
  currentHistory = currentHistory.filter(item => {
    return !(item.text === newItem.text && item.type === newItem.type);
  });
  currentHistory.unshift(newItem);
  setLocalHistory(currentHistory);
}

/**
 * 清空本地历史记录
 */
export function clearLocalHistory(): void {
  MStorage.removeStorageSync(HISTORY_KEY);
}
